import React, { createContext, useContext, useState, useCallback } from "react";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [scrollGatePassed, setScrollGatePassed] = useState(false);

  const openModal = useCallback((url) => {
    setRedirectUrl(url);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <ModalContext.Provider
      value={{
        showModal,
        openModal,
        closeModal,
        redirectUrl,
        scrollGatePassed,
        setScrollGatePassed,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};